// extracted by mini-css-extract-plugin
export default {"loading":"Loading_loading__B4MSm","dot":"Loading_dot__bvN0s","wave":"Loading_wave__feWVA"};